
(function() {
  var result = { translations: { "en": null } };
  result.translationsLoaded = {};
  result.translationsAvailable = {
  "signup-ui-lego": {
    "da": "static-1.7799",
    "de": "static-1.7799",
    "en": "static-1.7799",
    "es": "static-1.7799",
    "fi": "static-1.7799",
    "fr": "static-1.7799",
    "it": "static-1.7799",
    "ja": "static-1.7799",
    "nl": "static-1.7799",
    "no": "static-1.7799",
    "pl": "static-1.7799",
    "pt-br": "static-1.7799",
    "sv": "static-1.7799",
    "zh-tw": "static-1.7799"
  }
};
  hns('I18n', result);

})();


